<template>
    <div
        :data-theme="settings.footer_ColorTheme"
        :data-mode="settings.footer_ColorPalette"
        class="mt-auto pt-10 lg:pt-20 surface-background px-6 lg:px-0"
    >
        <div
            class="container-extra-wide mx-auto flex flex-col"
            :class="{
                'items-center': alignment === 'centred',
            }"
        >
            <div class="mb-6">
                <slot name="logo" />
            </div>

            <div class="flex flex-col space-y-11 w-full">
                <p
                    v-if="settings.footer_BodyText && settings.footer_BodyText.length > 0"
                    class="text-neutral-subtle text-base leading-base font-ux container"
                    :class="{
                        'text-center mx-auto': alignment === 'centred',
                    }"
                >
                    {{settings.footer_BodyText}}
                </p>

                <div
                    v-if="settings.footer_Quicklinks.length > 0"
                    class="flex flex-wrap gap-x-11 gap-y-2"
                    :class="{
                        'items-center justify-center': alignment === 'centred',
                    }"
                >
                    <NuxtLink
                        v-for="(quicklink, quicklinkIndex) in settings.footer_Quicklinks"
                        :key="quicklinkIndex"
                        :to="quicklink.url"
                        :target="quicklink.target"
                        class="font-semibold text-brand-extra-strong hover:underline underline-offset-2 text-lg"
                        no-prefetch
                    >
                        {{ quicklink.text }}
                    </NuxtLink>

                </div>

                <div
                    v-for="(contactDetails, contactDetailIndex) in settings.footer_ContactDetails"
                    :key="contactDetailIndex"
                >
                    <p
                        class="text-xs font-medium uppercase text-neutral-extra-subtle mb-3"
                        :class="{
                            'text-center': alignment === 'centred',
                        }"
                    >
                        {{ contactDetails.footerContactDetailsItem_Heading}}
                    </p>
                    <div
                        class="flex flex-wrap gap-x-9 gap-y-3"
                        :class="{
                            'items-center justify-center': alignment === 'centred',
                        }"
                    >
                        <NuxtLink
                            v-for="(contact, contactIndex) in contactDetails.footerContactDetailsItem_Links"
                            :key="contactIndex"
                            :to="contact.url"
                            :target="contact.target"
                            class="flex items-center space-x-1.5"
                        >
                            <DIcon
                                v-if="contact?.icon && contact.icon.name"
                                :icon="contact.icon.name"
                                :icon-set="contact.icon.set"
                                :type="contact.icon.type"
                                class="shape-brand-accent"
                            />
                            <span class="font-medium text-brand-extra-strong hover:underline underline-offset-2 text-sm">
                                {{ contact.text }}
                            </span>
                        </NuxtLink>
                    </div>
                </div>

                <!-- social links -->
                <div
                    v-if="socialLinks"
                    class="flex flex-wrap gap-x-5 gap-y-2"
                    :class="{
                        'items-center justify-center': alignment === 'centred',
                    }"
                >
                    <NuxtLink
                        v-for="(social, socialIndex) in socialLinks"
                        :key="socialIndex"
                        :to="social.url"
                        :target="social.target"
                        :aria-label="social.title || social.text || social.ariaLabel"
                        class="flex items-center justify-center w-8 h-8 surface-button-primary-2-default hover:surface-button-primary-2-hover button-brand-subtle-on-surface-default button-radius-base"
                    >
                        <DIcon
                            v-if="social?.icon && social.icon.name"
                            :icon="social.icon.name"
                            :icon-set="social.icon.set"
                            :type="social.icon.type"
                        />
                    </NuxtLink>
                </div>

                <div class="h-px w-full bg-[--border-subtle]" />

            </div>

            <div class="w-full py-6 space-y-6">
                <p
                    v-if="settings.footer_DisclaimerText && settings.footer_DisclaimerText.length > 0"
                    class="text-neutral-subtle text-sm leading-sm font-ux container"
                    :class="{
                        'text-center mx-auto': alignment === 'centred',
                    }"
                >
                    {{ settings.footer_DisclaimerText }}
                </p>

                <div
                    class="container-wide flex flex-col lg:flex-row flex-wrap gap-x-9 gap-y-4"
                    :class="{
                        'items-center justify-center mx-auto': alignment === 'centred',
                    }"
                >
                    <NuxtLink
                        v-for="(policy, policyIndex) in settings.footer_PolicyLinks"
                        :key="policyIndex"
                        :to="policy.url"
                        :target="policy.target"
                        class="font-medium text-brand-extra-strong text-sm"
                        :class="{
                            'underline lg:no-underline hover:underline underline-offset-2 ': !!policy.url,
                        }"
                    >
                        {{ policy.linkText }}
                    </NuxtLink>

                    <slot name="siteByDigistorm" />
                    <slot name="copyright" />
                </div>
            </div>

        </div>
    </div>
</template>

<script setup>
    import { DIcon } from '@digistorm/spark'

    const props = defineProps({
        settings: Object,
        socialLinks: Object,
    })

    const alignment = computed(() => {
        return get(props.settings, 'footer_Alignment')
    })

</script>